/* ============================================================
   Cart enhancements
   - Live free-shipping progress bar updates
   - Ensures cart drawer auto-opens after Add to Cart
   ============================================================ */

(function () {
  if (typeof window === 'undefined') return;

  const SELECTORS = {
    bar: '[data-cart-shipping-bar]',
    fill: '[data-cart-shipping-bar-fill]',
    text: '[data-cart-shipping-bar-text]',
  };

  function formatMoney(cents, currencyCodeEnabled) {
    if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') {
      const value = (cents / 100).toFixed(2);
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      return currencyCodeEnabled && currency ? `${value} ${currency}` : value;
    }

    const format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    let formatted = Shopify.formatMoney(cents, format);
    if (currencyCodeEnabled) {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      if (currency && !formatted.includes(currency)) {
        formatted = `${formatted} ${currency}`;
      }
    }
    return formatted;
  }

  function getCartSubtotalCents(cartData) {
    if (!cartData) return null;
    if (typeof cartData.items_subtotal_price === 'number') return cartData.items_subtotal_price;
    if (typeof cartData.total_price === 'number' && Array.isArray(cartData.items)) return cartData.total_price;
    return null;
  }

  function setFillProgress(bar, fill, percent) {
    const clamped = Math.min(100, Math.max(0, percent));
    const widthValue = `${clamped}%`;

    if (fill) {
      fill.style.setProperty('width', widthValue, 'important');
    }

    if (bar) {
      bar.dataset.progress = String(clamped);
      bar.setAttribute('aria-valuenow', String(clamped));
    }
  }

  function updateShippingBar(cartData) {
    const bar = document.querySelector(SELECTORS.bar);
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (threshold <= 0) return;

    const currencyCodeEnabled = bar.dataset.currencyCodeEnabled === 'true';
    const total = getCartSubtotalCents(cartData);
    if (total === null) return;

    let percent = Math.round(Math.min(100, Math.max(0, (total / threshold) * 100)));
    const remaining = Math.max(0, threshold - total);
    const qualified = total >= threshold;

    if (percent === 0 && total > 0 && remaining > 0) {
      percent = 1;
    }

    const fill = bar.querySelector(SELECTORS.fill);
    setFillProgress(bar, fill, percent);

    bar.classList.toggle('cart-shipping-bar--qualified', qualified);

    const textEl = bar.querySelector(SELECTORS.text);
    if (textEl) {
      if (qualified) {
        textEl.textContent =
          (window.cartShippingStrings && window.cartShippingStrings.qualified) || 'You unlocked free shipping!';
      } else {
        const amount = formatMoney(remaining, currencyCodeEnabled);
        const template =
          (window.cartShippingStrings && window.cartShippingStrings.remaining) ||
          'Add <strong>[amount]</strong> more to unlock free shipping';
        textEl.innerHTML = template.replace('[amount]', amount);
      }
    }
  }

  function applyProgressFromBarDataset() {
    const bar = document.querySelector(SELECTORS.bar);
    if (!bar) return;

    const percent = parseInt(bar.dataset.progress, 10);
    if (Number.isNaN(percent)) return;

    const fill = bar.querySelector(SELECTORS.fill);
    setFillProgress(bar, fill, percent);
  }

  function refreshFromCart() {
    if (!document.querySelector(SELECTORS.bar)) return;

    return fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.item_count) {
          applyProgressFromBarDataset();
          return;
        }
        updateShippingBar(data);
      })
      .catch(() => applyProgressFromBarDataset());
  }

  window.refreshCartShippingBar = refreshFromCart;

  function init() {
    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
      const observer = new MutationObserver(() => {
        if (drawer.classList.contains('active')) {
          requestAnimationFrame(() => {
            applyProgressFromBarDataset();
            refreshFromCart();
          });
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        requestAnimationFrame(() => {
          applyProgressFromBarDataset();
          refreshFromCart();
        });
      });

      if (drawer && typeof drawer.open === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!event || event.source !== 'product-form') return;
          if (!drawer.classList.contains('active')) {
            setTimeout(() => drawer.open(), 60);
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
